<template>
    <div class="qualityCheckManage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "qualityCheckManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
